import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from 'theme';
import { KeycloakProvider } from 'providers/KeycloakProvider';
import { LocalisationProvider } from 'providers/LocalisationProvider';
import { UiContextProvider } from 'providers/UiContextProvider';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from 'api/queryClient';
import { ProfileRouter } from 'pages/ProfileRouter';
import { FeatureFlagProvider } from 'providers/FeatureFlagProvider';

export default function ProfileApp() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <UiContextProvider>
          <LocalisationProvider>
            <KeycloakProvider>
              <FeatureFlagProvider>
                <ProfileRouter />
              </FeatureFlagProvider>
            </KeycloakProvider>
          </LocalisationProvider>
        </UiContextProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
